// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-m_fo","advertDetailContactGroup__header":"c-m_fp","advertDetailContactGroup__value":"c-m_fq"};